import { ProductCheckoutType } from './Product';

// TODO: move this to models project
export enum OrderCreationStatus {
  Pending,
  Success,
  Fail,
}

export enum OrderClaimStatus {
  None, // some orders are not for the calendar
  Success,
  Conflict,
  Gone,
  Error,
}

export interface CartItem {
  index?: number;
  productId: number;
  variationId?: number;
  groupedProductIds?: number[]; // for "Grouped" products - e.g. gift box + gift card bundle
  quantity?: number;
  price?: number;
  name: string;
  checkoutType: ProductCheckoutType;
}

export interface ShippingDetails {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  country?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  email?: string;
  shippingOptionName?: string;
}

export interface BillingDetails {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  country?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  email?: string;
}

export default interface Order {
  id: number;
  creationStatus: OrderCreationStatus;
  creationStatusMessage: string;
  errorMessage: string;
  subtotal: number;
  total: number;
  shippingCost: number;
  taxCost: number;

  orderDate: string;
  senderEmail: string;
  paymentMethod: string;
  tip: number;
  shipping: ShippingDetails;
  products: CartItem[]; // TODO: rename to cartItems (requires backend change)
  // claim as part of order
  claimStatus?: OrderClaimStatus; // someone else claimed the item immediately beforehand
  claimErrorMessage?: string;
}
